/* unplugin-vue-components disabled */import { render } from "./ai-profile-select.vue?vue&type=template&id=6f7e24ff&scoped=true"
import script from "./ai-profile-select.vue?vue&type=script&lang=js"
export * from "./ai-profile-select.vue?vue&type=script&lang=js"

import "./ai-profile-select.vue?vue&type=style&index=0&id=6f7e24ff&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7e24ff"],['__file',"src/components/ai-chat/ai-assistant/ai-input/ai-profile-select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f7e24ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f7e24ff', __exports__)) {
    api.reload('6f7e24ff', __exports__)
  }
  
  module.hot.accept("./ai-profile-select.vue?vue&type=template&id=6f7e24ff&scoped=true", () => {
    api.rerender('6f7e24ff', render)
  })

}


export default __exports__